import { useCallback, useEffect, useState } from "react";
import { fetchAllAccounts } from "services/services.accounts";

const useAccounts = ({ limit, offset, type, agency }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);

    fetchAllAccounts({
      url: "/auth/list-users",
      params: {
        limit,
        offset,
        type: type ?? null,
        agency: agency ?? null,
      },
      callback: (response) => {
        setData(response);
        setIsLoading(false);
      },
    });
  }, [limit, offset, type, agency]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useAccounts;
